const o = "_root_4irdo_1", t = "_iconCellRoot_4irdo_1", c = "_compact_4irdo_10", r = "_standard_4irdo_13", _ = "_comfort_4irdo_16", d = {
  root: o,
  iconCellRoot: t,
  compact: c,
  standard: r,
  comfort: _
};
export {
  _ as comfort,
  c as compact,
  d as default,
  t as iconCellRoot,
  o as root,
  r as standard
};
//# sourceMappingURL=index.es736.js.map
